import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ɵgetHostElement,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {

  TabPosition,
  TabStripTabComponent,
} from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import {
  AccountSummary,
} from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CategorySummary } from '~/models/modules/category';
import { CategoryFile } from '~/models/modules/categoryFile';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { AccountsService } from '~/services/administration.ts/accounts';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { FilesService } from '~/services/modules/stocks/files';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import {
  LayoutManagerService,
} from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { fileSources } from '~/shared/enums/fileSources';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { FileInfo, SelectEvent } from '@progress/kendo-angular-upload';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { ISiteDto } from '~/models/modules/Common/siteDto';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { AddressListing, AddressSummary } from '~/models/modules/address';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';

@Component({
    selector: 'app-upsert',
    templateUrl: './upsert.component.html',
    styleUrls: ['./upsert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultiSiteUpsertComponent extends MultiSiteAwareComponent
  implements OnInit, OnDestroy, AfterContentChecked {
  _currentUser: UserSummary;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _imageColumnsMap: GridColumnMap[] = [];
  _accounts: AccountSummary[];
  _selectedAccounts: any[] = [];
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _theme: string;
  _isNew: boolean;
  _form: FormGroup;
  _active: boolean;
  _listbarcodegenerator: Array<any> = [];
  _isAutoGeneratingNumber: boolean;
  _showImagesGrid: boolean;
  declare _tabEnabled: boolean;
  _invalidForm: boolean;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _model: ISiteDto = null;
  _siteCode = new FormControl();
  _pageState: PageState;
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _addClassActive: boolean = false;
  _editFormActive: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _selectedAccountIds: any[] = [];
  _customValidation: any = [];
  _imageSearchControl = new FormControl();
  _imageSearchResult: string;

  _customFields: CustomFieldSummary[][] = [];
  _customFieldsValue: any = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedLabelId: number;
  _customTabs: any;
  _page = 'sites';
  _permissionScope = 'sites';
  _gridFieldText: GridFieldTextSummary[];
  _language: string = 'en';
  _selectedLabelObjectCode: any;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  quantities = Array<any>();
  dates = Array<any>();

  _index: number;
  _systemFields: Array<any> = [];
  _requiredFields: Array<any> = [];
  _customRequiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _isEditForms: boolean = false;

  _selectedObjectImages: any[] = [];
  _stockItemFilesPics: CategoryFile[] = [];

  // #region Graphs
  public _donutChartSmall: any[] = [
    {
      data: [
        {
          category: 'Safe Workplace',
          value: 30,
          color: '#e7e0fc',
          colorLabel: '#321982',
          font: '8px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'DC Health',
          value: 40,
          color: '#d1c7f0',
          colorLabel: '#321982',
          font: '8px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'District Logistics',
          value: 120,
          color: '#b3a5e3',
          colorLabel: '#321982',
          font: '8px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 180,
      title: 'Category(name)',
    },
  ];

  reactivate: boolean = false;
  reactivateItem: any;

  public _donutChartLarge: any[] = [
    {
      data: [
        {
          category: 'Safe Workplace',
          value: 30,
          color: '#e7e0fc',
          colorLabel: '#321982',
          font: '13px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'DC Health',
          value: 40,
          color: '#d1c7f0',
          colorLabel: '#321982',
          font: '13px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'District Logistics',
          value: 120,
          color: '#b3a5e3',
          colorLabel: '#321982',
          font: '13px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 180,
      title: 'Category(name)',
    },
  ];
  // #endregion
  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _SIQChartForm: boolean = false;
  _imageTabActive: boolean = false;
  _SIQActive: boolean = true;
  _showimageTab: boolean = false;
  listLocationQty: any;
  deactivatedFieldsGridData: any[] = [];
  urlAndStream: string;
  StockQtyInCategoryPerDate: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _orderingTabsForm: boolean = false;
  _gridFieldAuth: GridFieldAuthorization[];
  _isMandatory: boolean = false;
  _isLiveEnterprise: boolean;
  _isDialiogCategory: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;

  stockItemQuantityChartDetail: StartEndDateChartResponseModel;
  stockItemQuantityChart: Chart;
  stockItemQuantitySecondChart: Chart;
  isStockItemGridExpanded: boolean = true;
  isStockItemChartExpanded: boolean = true;
  _storagePath: string;
  _isOs: boolean;
  _entity = 'common'
  //#region  ViewChild
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('kendo_BarcodeGen_Site_Code')
  kendoBarcodeGenSiteCode: ElementRef;
  @ViewChild('kendo_Input_Site_Name')
  kendoInputSiteName: ElementRef;
  @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('note') note: NoteComponent;
  copyModelId: number;
  _gridColumns: GridFieldSummary[];
  _gridColumnsDuplicate: GridFieldSummary[];
  behavior: BehaviorSubject<GridFieldSummary[]>;
  //#endregion
  _selectedAccount = new FormControl();
  //#region Logo Fields
  LogoImageFile: Array<FileInfo> = [];
  myFiles: Array<FileInfo> = [];
  _imageStream: any;
  _file: File;
  LogoImageFileId: string = '';
  logoImagePath: string = '';
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.image];
  //#endregion
  //#region Ship to Address Fields
  _addresses: any[] = [];
  _addressesFiltered: any[] = [];
  _showAddressGrid: boolean = false;
  _selectedaddresses: any[] = [];
  _AddressesColumns: GridFieldSummary[];
  _selectedShipToAddresses: any = [];
  _selectedCallback = (args: { dataItem: any }) => args.dataItem;
  @ViewChild('kendo_multiselect') kendoMultiselect: MultiSelectComponent;
  //#endregion
  //#region  CTOR
  constructor(
    private _accountsService: AccountsService,
    private _filesService: FilesService,
    private _sitesService: MultiSiteService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    public cdRef: ChangeDetectorRef,
    private _sharedService: SharedService,
    private _gridLayoutManagerServicelocation: GridLayoutManagerService,
    private _addressesService: AddressesService
  ) {
    super();
    this._isLiveEnterprise = environment.liveEnterprise;


    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();

    if (
      this._pageState == PageState.EDIT ||
      this._pageState == PageState.VIEW
    ) {
      this._getLogoImage();
      // this._selectedAccounts = this._model.categoryAccounts.map(
      //   (x: RelationAccount) => {
      //     return +x.account.id;
      //   }
      // );

      //this._tabEnabled = this._selectedAccounts.length > 0;
    }
    this._currentUser = this._securityService.currentUser;


    this.loadLabels();
    this._customFieldsService
      .getDeactivatedCustomFields('common', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(
          (x) => x.formTab.page === this._page
        );
      });

    this.behavior = this._gridLayoutManagerServicelocation.subscribeToColumnsChanges2()

    this.behavior.subscribe((value: any) => {
      if (value != undefined && value != null) {
        //let pagename = value.map((a:any) => a.page).shift();
        let pagename = 'files'
        let Gridresualt = value.filter((a: any) => a.selected === true && a.page === pagename);

        switch (pagename) {
          case 'files':
            this._gridColumns = Gridresualt;
            break;

          case 'locations':
            this._gridColumns = Gridresualt;
            break;

          default:
            break;
        }
      }
    })
  }

  //#endregion

  //#region  OnInit
  ngOnInit() {
    this._gridFields
      .getGridFieldsByPage('addresses')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('addresses', data);
      });
    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('addresses', (gridColumns) => {
      this._AddressesColumns = gridColumns;
    }));
    this.loadAddresses();

    if (!this._currentUser.isEnterprise) {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
      if (loggedInAccountSites != "") {
        var accountId = JSON.parse(loggedInAccountSites)[0].accountId;
        this._selectedAccount.setValue({ id: accountId });
        // var siteId = JSON.parse(loggedInAccountSites)[0].siteId;
        // this._loggedInSiteId = siteId;
        // this._form.patchValue({
        //     site: { id: siteId, name: "" }
        // });
        //this._loadInventoriesForReturn(siteId, 0);
      }
    }
    this._initForm();

    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }



    this.getFormTabs();
    this.getAuth();
    this.getSystemFieldsAndCustomFields();
  }
  //#endregion
  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this._systemFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });

    this._systemFields.find((x: { id: any; }) => x.id === oldLocData.id).formOrder =
      sysFClone.find((x) => x.id === newLocData.id).formOrder;
    this._systemFields.find((x: { id: any; }) => x.id === newLocData.id).formOrder =
      sysFClone.find((x) => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = this._systemFields;
  }
  dragEnd() {
    this._gridFields
      .updatedSystemFieldReorder(this._editedSystemFields)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }
  //#region  _getdata
  _getdata() {
    this._model =
      this._sharedService.model && this._sharedService.model.model
        ? this._sharedService.model.model
        : null;
    this._pageState =
      this._sharedService.model && this._sharedService.model.pageState
        ? this._sharedService.model.pageState
        : null;
    this._active = true;


    if ((this._pageState === PageState.ADD || this._pageState === PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }


  }
  //#endregion



  //#endregion



  //#region  ngAfterContentChecked
  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }
  //#endregion





  //#region  _onEditFields
  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the desired account in the Accounts Tab',
          withoutConfirm: true
        });
      } else {
        this._editFormActive = true;
        this._isCustomfieldsFormValue = true;
      }
    }
  }
  //#endregion

  //#region  _openForm
  _openForm(componentName: string, isDocument = false) {
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, isDocument, reload: 'model', fileSource: fileSources.category };
    this._isDialiogCategory = true;
  }
  //#endregion

  //#region  _reactivate
  // _viewInactiveFields() {
  //     .getDeactivatedCustomFields('stock',this._page)
  //     
  //     .subscribe((data: Array<any>) => {
  //       this._deactivatedFieldsGridData = data.filter(
  //         (x) => x.formTab.page === this._page
  //       );
  //     });
  //   this._deactivatedFieldsForm = true;
  // }
  _viewInactiveFields(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
        if (!onLoad)
          this._deactivatedFieldsForm = true;
      });
  }
  //#endregion

  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  //#region  _reactivate
  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService
          .reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  this.getFormTabs();
                  this._viewInactiveFields(true);
                  this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name,
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  //#endregion

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = false;
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  //#region _closeCustomFields
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    this.getSystemFieldsAndCustomFields();
    // this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  //#endregion

  //#region  _edit
  _edit() {
    this._pageState = PageState.EDIT;
    this.accountTab.selected = true;
    this.accountTab.disabled = false;
  }
  //#endregion

  //#region  Actions CirclesForm
  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }
  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }
  //#endregion

  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };

  _getAccountImages = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAccountsPictures(
      this._selectedAccounts,
      params,
      model
    );
  };

  _getSelectedImages = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getPictures(params, model);
  };

  _barcodeSubmited() {
    this._siteCode.setValue(this._form.get('code').value);

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputSiteName.nativeElement.focus();
        let siteName = this.kendoInputSiteName;
        siteName.nativeElement.classList.add('focusedInput');
      });
    }
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    } else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    } else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }
  //#region  ngOnDestroy
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }
  //#endregion


  //#region _skipSiteName
  _skipSiteName() {
    if (this._pageState == PageState.ADD) {
      let SiteName = this.kendoInputSiteName;
      SiteName.nativeElement.classList.remove('focusedInput');
      this._addClassActive = true;
    }
  }
  //#endregion

  //#region  _removeTabActiveAndRemoveSkip
  _removeTabActiveAndRemoveSkip() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let SiteName = this.kendoInputSiteName;
      SiteName.nativeElement.classList.remove('focusedInput');
    }
  }
  //#endregion

  _removeTabActiveAndSkipAdd() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let SiteName = this.kendoInputSiteName;
      SiteName.nativeElement.classList.add('focusedInput');
    }
  }
  _SiteNameSubmited() {
    if (this._pageState == PageState.ADD) {
      let SiteName = this.kendoInputSiteName;
      SiteName.nativeElement.classList.remove('focusedInput');
      SiteName.nativeElement.blur();
      this._addClassActive = true;
    }
  }
  _SiteNameFocusout() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let SiteName = this.kendoInputSiteName;
        SiteName.nativeElement.classList.remove('focusedInput');
        SiteName.nativeElement.blur();
      }, 100);
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }
  getCategoryImagePath(path: any): any {
    var PrimaryImage = '';

    PrimaryImage = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + path;
    return PrimaryImage;
  }
  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showImagesGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = true;
    }
  }



  _onTabSelect(e: any) {
    this._mobileMenuToggle();
    if (e.title == 'Logo') {
      // this._fileSelectedChanges(event, true)
      if (this.LogoImageFile.length > 0) {
        setTimeout(() => {
          document.getElementsByClassName("k-file-group-wrapper ")[0].innerHTML = "";
          var element = document.createElement('img');
          element.src = this._imageStream;
          element.style.position = "relative";
          element.style.verticalAlign = "top";
          element.style.height = "50px";
          document.getElementsByClassName("k-file-group-wrapper ")[0].replaceWith(element);
        }, 500);

      }
    }
    if (this._currentUser.isEnterprise) {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
        e.preventDefault();
        return;
      }
    } else if (!this._currentUser.isEnterprise) {
      //e.preventDefault();
    }
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }


  //#region  Form Actions
  _onSave(e: any) {
    this.submit(e);
  }

  _onEditForm() { }

  _onCancel() {
    this._closeForm();
  }


  reloadlist: any;
  _closeForm(poModel: any = null) {

    this.reloadlist = this._sharedService.model.reload;
    var closeComponent = {
      component: this._page,
      isClosed: true,
      response: this.reloadlist === undefined ? null : poModel,
      retCategory: poModel
    };


    this._gridLayoutManagerService.setGridDataSubjects('categories');
    this._layoutManager.setFromChanged('categories');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    this._sharedService.model = {};

  }
  //#endregion

  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }

  //#region Logo Functions
  async _uploadProfileImage(imageModel: any, e: string, model: any) {
    if (this._pageState == PageState.ADD) {
      this._doUploadImage(imageModel, e, model, true);
    }
    else if (this._pageState == PageState.EDIT) {
      let imageId = model["logoId"];

      if (imageId != null && imageId != '') {
        this._doUploadImage(imageModel, e, model, false, imageId);
      }
      else {
        this._doUploadImage(imageModel, e, model, true);
      }
    }
  }
  _doUploadImage(imageModel: any, e: string, model: any, isNew: boolean = true, imageId: number = 0) {
    if (isNew == true) {
      this._filesService.createFile(imageModel).subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this.LogoImageFile = response["responseId"];
          model["logoId"] = this.LogoImageFile;
          this.logoImagePath = imageModel.stream;
          this._doSubmit(e, model);
        }
      });
    }
    else {
      this._filesService.updateFile(imageId, imageModel).subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this.logoImagePath = imageModel.stream;
          this._doSubmit(e, model);
        }
      });
    }
  }

  _fileSelectedChanges(ev: SelectEvent) {
    this.LogoImageFile = [];

    if (ev)
      ev.files.forEach((file: FileInfo) => {
        if (file.rawFile) {
          var isValid = this.checkFileExtention(file.rawFile);
          if (!isValid) {
            this.myFiles = [];
            this._imageStream = null;
            return;
          }
          else {
            this.LogoImageFile.push(file);
            this._file = file.rawFile;
            const reader = new FileReader();
            reader.readAsDataURL(file.rawFile);
            reader.onloadend = () => {
              this._imageStream = reader.result;
              let imgElement = "<img src=" + this._imageStream + "/>";

              document.getElementsByClassName("k-file-group-wrapper ")[0].innerHTML = "";
              var element = document.createElement('img');
              element.src = this._imageStream;
              element.style.position = "relative";
              element.style.verticalAlign = "top";
              element.style.height = "50px";
              document.getElementsByClassName("k-file-group-wrapper ")[0].replaceWith(element);


            };
          }
        }
      });
  }
  checkFileExtention(file: any) {
    let isValid = false;
    let fileUploadedName = file.name;
    const allowedExtensions = ['png', 'jpeg', 'jpg'];
    const reg = /(?:\.([^.]+))?$/;
    const fileType = reg.exec(fileUploadedName)[1].toLowerCase();
    if (allowedExtensions.indexOf(fileType) == -1) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Only PNG, JPG, JPEG extensions are allowed.',
        withoutConfirm: true
      });

      isValid = false;
    } else {
      isValid = true;
    }

    return isValid;
  }
  _fileRemoveEventHandler() {
    this._imageStream = null;
  }
  _getLogoImage() {
    this.logoImagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + this._model?.logo?.stream;
    return this.logoImagePath;// EnvironmentLoaderService.envConfig.enterpriseApiLocal+'/'+this._model.person?.profileImage?.stream
  }

  //#region Ship to Address Functions
  //#region  _multiSelectClose
  _multiSelectClose(e: any) {
    if (!ɵgetHostElement(this.kendoMultiselect).contains(e.target)) {
      //this.kendoMultiselect.toggle(false);
    }
  }
  //#endregion
  loadAddresses() {
    this._addressesService.getAddressesListing().subscribe((x: any) => {

      this._addresses = x;
      this._addressesFiltered = x;
      if (this._model.shipToAddresses) {
        this._selectedShipToAddresses = [];
        this._model.shipToAddresses.forEach(shipToAddress => {
          let shipToAddressObject = this._addresses.find((x: AddressListing) =>
            x.id == shipToAddress.addressId);
          if (shipToAddressObject)
            this._selectedShipToAddresses.push(shipToAddressObject);
        });


      }
      else
        this._selectedShipToAddresses = [];
    });
  }
  _isAddressSelected(id: any) {
    return this._selectedShipToAddresses.some((item: any) => item.id === id);
  }
  _handleAddressesChange(value: any) {

  }
  _returnSelectedHandler(e: any): void {

    switch (e.currentTarget.id) {
      case 'buttselectreturnaddresses':
        this._showAddressGrid = false;

        this._selectedaddresses.forEach((item: any) => {
          // this._form.controls.address.setValue(item);
          if (!this._selectedShipToAddresses.find((x: any) => x.name == item.name))
            this._selectedShipToAddresses.push(item);
        });
        break;


      default:
        break;
    }
    e = null;

  }
  _selectOpenCloseHandler(openclose: boolean, e: any): void {

    if (e === undefined) {

      this._showAddressGrid = openclose;
      return;
    }

  }
  _onaddressesRowSelectionChanges(e: any[]) {
    this._selectedaddresses = [];
    //this._selectedShipToAddresses = [];
    e.forEach((item) => {
      this._selectedaddresses.push(item);
      //this._selectedShipToAddresses.push(item);
    });
  }
  _getAddressesGridList = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      return this._addressesService.getAddresses(params, model);
    }
  }
  _FetchAllAddressdOpenCloseHandler(openclose: boolean): void {
    this._showAddressGrid = openclose;
  }
  _handleAddressesFilter(value: any) {
    this._addressesFiltered = this._addresses.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  //#endregion
  //#endregion
  private _initForm() {
    this._form = this._fb.group({
      code: [this._model && this._model.code, Validators.required],
      logoId: [(this._model) && (this._pageState == PageState.EDIT) ? this._model.logoId : null],
      name: [
        this._model && this._model.name,
        this.getLabel('LBL_SitesFileName')?.isRequired ? Validators.required : null],
      address1: [
        this._model && this._model.address1,
        this.getLabel('LBL_SitesFileAddress1')?.isRequired ? Validators.required : null,
      ],
      address2: [
        this._model && this._model.address2,
        this.getLabel('LBL_SitesFileAddress2')?.isRequired ? Validators.required : null,
      ],
      phone1: [
        this._model && this._model.phone1,
        this.getLabel('LBL_SitesFilePhone1')?.isRequired ? Validators.required : null,
      ],
      contact: [
        this._model && this._model.contact,
        this.getLabel('LBL_SitesFileContact')?.isRequired ? Validators.required : null,
      ],
      country: [
        this._model && this._model.country,
        this.getLabel('LBL_SitesFileCountry')?.isRequired ? Validators.required : null,
      ],
      city: [
        this._model && this._model.city,
        this.getLabel('LBL_SitesFileCity')?.isRequired ? Validators.required : null,
      ],
      state: [
        this._model && this._model.state,
        this.getLabel('LBL_SitesFileState')?.isRequired ? Validators.required : null,
      ],

      lng: [
        this._model && this._model.lng,
        this.getLabel('LBL_SitesFileLNG')?.isRequired ? Validators.required : null,
      ],
      lat: [
        this._model && this._model.lat,
        this.getLabel('LBL_SitesFileLAT')?.isRequired ? Validators.required : null,
      ],
      email: [
        this._model && this._model.email,
        this.getLabel('LBL_SitesFileEmail')?.isRequired ? Validators.required : null,
      ],
      fax: [
        this._model && this._model.fax,
        this.getLabel('LBL_SitesFileFax')?.isRequired ? Validators.required : null,
      ],
      zip: [
        this._model && this._model.zip,
        this.getLabel('LBL_SitesFileZip')?.isRequired ? Validators.required : null,
      ],
    });
  }
  _additionalErrors: any = [];

  //#region  submit
  private submit = (e: string) => {
    this._additionalErrors = [];
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the Site for the desired Account.',
          withoutConfirm: true
        });
        return;
      }
    }
    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidForm = true;
      this._invalidSubmit = true;
    } else if (this._form.invalid) {
      this._invalidForm = true;
    } //else if (this._custominvalidForm && this._customValidation.find((x: any) => !x.value) )
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    } else {

      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;
      if (this._customFieldsValue) {
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }
      model['customFieldsValue'] = this._customFieldsDictionary;
      model['accountId'] = this._selectedAccount.value?.id ?? 0;
      model['shipToAddresses'] = [];
      this._selectedShipToAddresses.forEach((element: AddressListing) => {
        let shipToaddress = {
          siteId: this._model.id ? this._model.id : 0,
          addressId: element.id
        };
        model['shipToAddresses'].push(shipToaddress);
      });
      // model['fileIds'] = this._selectedImagesKeys;
      let profileImageModel: any = {};
      if (this._imageStream) {
        profileImageModel.stream = this._imageStream;
        profileImageModel.size = this._file.size;
        profileImageModel.type = this._file.type;
        profileImageModel.fileSourceId = fileSources.users;
        profileImageModel.typesToChecks = this._allowedFileTypes;
        profileImageModel.exension = this._file.name.substring(this._file.name.lastIndexOf(".") + 1).toLowerCase();
        profileImageModel.name = model.code;// this._file.name ? this._file.name.substring(0, this._file.name.lastIndexOf('.')) : '';
        profileImageModel['accountIds'] = this._selectedAccount.value ? [this._selectedAccount.value.id] : [];
        this._uploadProfileImage(profileImageModel, e, model);
      }
      else {
        this._doSubmit(e, model);
      }

    }
  };
  _doSubmit(e: string, model: ISiteDto) {
    if (
      this._pageState == PageState.EDIT ||
      this._pageState == PageState.VIEW
    ) {

      this._sitesService
        .updateSite(this._model.id, model)

        .subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                if (e === 'saveAndClose') {
                  this._closeForm(response);
                } else if (e === 'saveAndCopy') {
                  this.copyModelId = this._model.id;
                  this._pageState = PageState.ADD;
                  this._form.controls.code.setValue(null);
                  this.loadCustomFields();
                } else if (e === 'saveAndNew') {
                  this.openUpsert(this._page, {}, PageState.ADD);
                  //this._closeForm();
                }

              } else {
                return;
              }
            }
          }
          // this._closeForm();
        });
    } else {
      this._sitesService
        .createSite(model)

        .subscribe((response: any) => {
          if (response != null && response['message'] != null) {

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                if (!this._currentUser.isEnterprise) {
                  this.note.createNote(response.responseId);
                }
                if (e === 'saveAndClose') {
                  model.id = response.responseId;
                  this._closeForm(model);
                  //   this._closeForm(response);
                } else if (e === 'saveAndCopy') {
                  this.copyModelId = this._model.id;
                  this._form.controls.code.setValue(null);
                  // this.loadCustomFields();
                } else if (e === 'saveAndNew') {
                  this.openUpsert(this._page, {}, PageState.ADD);
                  //this._closeForm();
                }
                else if (e === 'save') {
                  this._pageState = PageState.EDIT;
                  this._model.id = response.responseId;
                }
              } else {
                return;
              }
            }
          }
          // this._closeForm();
        });
    }
  }
  //#endregion
  //#region  loadCustomFields
  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService
      .getCustomFields('common', this._page, entityId)

      .subscribe((data) => {
        if (this._model != null && this._model.id != null || this.copyModelId != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter(
              (x: { isCustom: boolean }) => x.isCustom == true
            );
            this.setMandatoryFields();
          });
      });
  }
  //#endregion
  //#region  groupBy
  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
  //#endregion
  //#region  _customFieldsValueChanges
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    // Object.keys(customFieldsValue).forEach((key) => {
    //   if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
    //     customFieldsValue[key] = '';
    //   }
    //   if (
    //     this._customFields[tabId].find((x) => x.name == key).entityId == undefined ||
    //     this._customFields[tabId].find((x) => x.name == key).customFieldsData.length == 0) {
    //     //new mode, custom field data not added yet
    //     this._customFields[tabId].find((x) => x.name == key).entityId = -1;
    //     this._customFields[tabId]
    //       .find((x) => x.name == key)
    //       .customFieldsData.push({ id: -1, value: 'null', entityId: -1 ,customFieldId:-1});
    //   }
    //   var customFieldData = this._customFields[tabId]
    //     .find((x) => x.name == key)
    //     .customFieldsData.find(
    //       (x) =>
    //         x.entityId ==
    //         this._customFields[tabId].find((x) => x.name == key).entityId
    //     );
    //   if (customFieldData != undefined) {
    //     customFieldData.value = customFieldsValue[key];
    //   }
    // });
    // this._customFieldsValue = customFieldsValue;
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }
  //#endregion
  //#region  _removeCustomField
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (
          this._customFields[i].findIndex((x) => x.id == customFieldId) != -1
        ) {
          this._customFields[i] = this._customFields[i].filter(
            (x) => x.id != customFieldId
          );
          this.setMandatoryFields();
          this._viewInactiveFields(true);
          return;
        }
      }
    }
  }
  //#endregion
  //#region  _deactivateTab
  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == 'categories' ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response['message'] != null) {
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter(
                (x: { isCustom: boolean }) => x.isCustom == true
              );
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          if (response['close'] != null) {
            if (response['close'] == true) {
              // this._closeForm();
            } else {
              return;
            }
          }
        }
        //   this._closeForm();
      });
  }
  //#endregion
  //#region  getLabel
  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (
        this._gridFieldText.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldText.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : null;
    }
  }
  //#endregion
  //#region loadLabels
  private loadLabels() {
    this._gridFields
      .getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }
  //#endregion

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find(
        (x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)
      ).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }
    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }
  _onSaveTabOrdering() {
    this._gridFields
      .updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      });
  }

  getFormTabs() {
    this._gridFields
      .getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  getSystemFields() {
    this._gridFields
      .getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this._model?.id?.toString());
        //this.setMandatoryFields();
      })
  }
  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields
      .getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (
        this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }
  requiredSystemTabs: any = [];
  // setMandatoryFields() {
  //   this._requiredFieldNames = [];
  //   this._requiredFields = [];
  //   this.requiredSystemTabs = [];
  //   setTimeout(() => {
  //     for (let item of this._systemFields) {
  //       if (item.gridFieldText.isRequired) {
  //         this._requiredFields.push(item);
  //       }
  //     }

  //     for (let item2 of this._customFields) {
  //       if (item2) {
  //         for (let item3 of item2) {
  //           if (item3.isRequired) {
  //             this._requiredFields.push(item3);
  //           }
  //         }
  //       }
  //     }

  //     this._requiredFields.forEach((element) => {
  //       if (!element.isCustomField && element.isCustomField == null) {
  //         var tabName = element.formTab;
  //         this._requiredFieldNames.push(tabName);
  //       }
  //       else
  //       {
  //         if(element.formTabId)
  //         {
  //           let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
  //           if(SystemFieldTab)
  //           this.requiredSystemTabs.push(SystemFieldTab);
  //         }
  //       }
  //     });

  //     let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
  //     Array.from(tabElementList.children).forEach((child: any) => {

  //       child.classList.remove('mendatoryTab');
  //   });
  //     Array.from(tabElementList.children).forEach((child: any) => {
  //       if (
  //         this._requiredFieldNames.find(
  //           (x) => x.name === child.firstChild.innerText
  //         )
  //       ) {
  //         child.classList.add('mendatoryTab');
  //       }
  //       if (
  //         this.requiredSystemTabs.find(
  //           (x : any) =>
  //             x.name === child.firstChild.innerText
  //         )
  //       ) {
  //         child.classList.add('mendatoryTab');
  //       }
  //     });
  //   }, 500);
  // }
  setMandatoryFields() {

    //this.getSystemFields();
    //this.loadCustomFields(this._model?.id?.toString());
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (
          item.gridFieldText?.isRequired &&
          item.page?.trimEnd('') == this._page
        ) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired && item3.formTab?.page == this._page) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element) => {

        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      let tabElementList = this.navTrigger.nativeElement.querySelector('ul');


      Array.from(tabElementList.children).forEach((child: any) => {

        child.classList.remove('mendatoryTab');
      });


      Array.from(tabElementList.children).forEach((child: any) => {
        if (child.firstChild.innerText == 'General') {
          child.classList.add('mendatoryTab');
        }
        if (child.firstChild.innerText == 'Costing') {
          child.classList.add('mendatoryTab');
        }
        if (
          this._requiredFieldNames.find(
            (x) =>
              x.name === child.firstChild.innerText &&
              (x.page
                ? x.page.trimEnd('') == this._page
                : x.formTab.page.trimEnd('') == this._page)
          )
        ) {
          child.classList.add('mendatoryTab');
        }
        if (
          this.requiredSystemTabs.find(
            (x: any) =>
              x.name === child.firstChild.innerText
          )
        ) {
          child.classList.add('mendatoryTab');
        }
      });


      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';
          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);
  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiogCategory = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
  }

  _closeDialog(event: any) {
    /* if (event?.response && event.component == 'files') {
      this.GetImageById(event.response);
      this._isDialiogCategory = event.open;
    } else {
      this._isDialiogCategory = event;
    } */
  }

  GetImageById(id: number) {
    this._filesService
      .getFile(id)
      .pipe()
      .toPromise()
      .then((data) => {
        var categoryFile = new CategoryFile();
        categoryFile.file = data;

        this._stockItemFilesPics.push(categoryFile);
      });
  }

  ExpandCollapseStockItemGrid(isExpand: boolean) {
    this.isStockItemGridExpanded = !isExpand;
  }

  ExpandCollapseStockItemChart(isExpand: boolean) {
    this.isStockItemChartExpanded = !isExpand;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }


}
